var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.125C12 3.50368 12.5056 2.99275 13.1221 3.07022C14.387 3.22917 15.6082 3.65566 16.7025 4.32624C18.1177 5.19348 19.2655 6.43519 20.0191 7.91409C20.7726 9.39298 21.1025 11.0514 20.9723 12.7061C20.842 14.3608 20.2568 15.9473 19.2812 17.2901C18.3055 18.6329 16.9776 19.6797 15.4442 20.3149C13.9107 20.9501 12.2315 21.1488 10.5921 20.8892C8.95272 20.6295 7.41709 19.9216 6.15497 18.8437C5.17906 18.0101 4.39607 16.9805 3.85402 15.8266C3.58985 15.2643 3.91952 14.6255 4.51043 14.4335C5.10134 14.2415 5.728 14.5711 6.01537 15.122C6.41368 15.8855 6.95611 16.5689 7.61623 17.1327C8.56282 17.9412 9.71454 18.4722 10.9441 18.6669C12.1736 18.8616 13.433 18.7126 14.5831 18.2362C15.7332 17.7598 16.7292 16.9747 17.4609 15.9676C18.1926 14.9604 18.6315 13.7706 18.7292 12.5296C18.8269 11.2886 18.5794 10.0447 18.0143 8.93556C17.4491 7.82639 16.5883 6.89511 15.5269 6.24468C14.7867 5.79109 13.9691 5.48641 13.1198 5.34353C12.5071 5.24045 12 4.74632 12 4.125Z",
    fill: "#242426"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/Loading.df5649b61dabb225e42834d64a57b3dd.svg";
export { ForwardRef as ReactComponent };